import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import ResumeView from "@/views/ResumeView.vue";
import MikeTestimonial from "@/views/MikeTestimonial.vue";
import GSTestimonial from "@/views/GSTestimonial.vue";
import BlogView from "@/views/BlogView.vue";
import ContactView from "@/views/ContactView.vue";
import BlogPost1 from "@/components/BlogPost1.vue";
import BlogPost2 from "@/components/BlogPost2.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "HomeView",
      component: HomeView,
    },
    {
      path: "/resume",
      name: "ResumeView",
      component: ResumeView,
    },
    {
      path: "/testimonials/1",
      name: "MikeTestimonial",
      component: MikeTestimonial,
    },
    {
      path: "/testimonials/2",
      name: "GSTestimonial",
      component: GSTestimonial,
    },
    {
      path: "/blog",
      name: "BlogView",
      component: BlogView,
    },
    {
      path: "/contact",
      name: "ContactView",
      component: ContactView,
    },
    {
      path: "/blog/1",
      name: "BlogPost1",
      component: BlogPost1,
    },
    {
      path: "/blog/2",
      name: "BlogPost2",
      component: BlogPost2,
    },
  ],
});

export default router;
